import React from 'react';
import { useTranslation } from 'react-i18next';
import './UpdateBanner.css';

/**
 * «Hay una versión nueva» — ofrece recargar, nunca recarga solo.
 *
 * ⚠️ ESTE COMPONENTE ESCUCHABA AL SERVICE WORKER, Y NO PODÍA FUNCIONAR.
 * Se suscribía a `navigator.serviceWorker.ready` y a `updatefound`, pero el SW que
 * esta aplicación registra (`src/service-worker.js`) es un KILL-SWITCH: reclama los
 * clientes, borra las cachés y **se desregistra a sí mismo** en su `activate`. No
 * queda ningún SW persistente sobre el que disparar `updatefound`, así que el banner
 * no aparecía jamás.
 *
 * Peor: estaba escrito, con estilos y traducciones, y se veía en el código — o sea que
 * daba la impresión de que el problema estaba cubierto. Es «lo que no se lee no avisa»
 * en su forma más cara: una protección que sólo existe de adorno.
 *
 * Desde el 21-sep-2026 quien decide es `utils/deteccionDeVersion.js`, comparando el
 * sello del build contra `/version.json`. Este componente sólo pinta y llama a
 * `onUpdate`. El `controllerchange` que recargaba la página también se fue: recargar
 * sin preguntar le borra el texto a un agente a medio escribir.
 */
const UpdateBanner = ({ onUpdate }) => {
  const { t } = useTranslation('common');

  return (
    <div className="update-banner">
      <span>{t('updateBanner.message', 'Hay una versión nueva disponible')}</span>
      <button onClick={onUpdate}>
        {t('updateBanner.action', 'Recargar')}
      </button>
    </div>
  );
};

export default UpdateBanner;
